export default{
    language:[
        {
            value:'zh',
            label:'简体中文'
        },
        {
            value:'en',
            label:'英文'
        },
    ],
    language1:[
        {
            value:'zh',
            label:'Simplified Chinese'
        },
        {
            value:'en',
            label:'English'
        },
    ]
    
}